import React from "react";

export type MobileActionSeverity = "secondary" | "danger" | "primary" | "success";

interface MobileActionButtonProps {
    label: string;
    icon?: string;
    severity?: MobileActionSeverity;
    onClick: (e: React.MouseEvent) => void;
    disabled?: boolean;
    className?: string;
}

export const MobileActionButton: React.FC<MobileActionButtonProps> = ({
    label,
    icon,
    severity = "secondary",
    onClick,
    disabled = false,
    className = "",
}) => {
    const getStyles = () => {
        switch (severity) {
            case "danger":
                return {
                    backgroundColor: "#DC2626",
                    color: "#FFFFFF",
                    border: "none",
                };
            case "primary":
                return {
                    backgroundColor : "#0084D1",
                    color: "#FFFFFF",
                    border: "none",
                };
            case "success":
                return {
                    backgroundColor: "#059669",
                    color: "#FFFFFF",
                    border: "none",
                };
            case "secondary":
            default:
                return {
                    backgroundColor: "#FFFFFF",
                    color: "#334155",
                    border: "1px solid #E2E8F0",
                };
        }
    };

    const s = getStyles();

    return (
        <button
            type="button"
            disabled={disabled}
            onClick={(e) => {
                e.stopPropagation();
                onClick(e);
            }}
            className={`cursor-pointer flex align-items-center gap-1 px-3 py-2 border-round-md transition-all ${className}`}
            style={{
                ...s,
                fontSize: "0.8rem",
                fontWeight: 600,
                outline: "none",
                opacity: disabled ? 0.5 : 1,
            }}
        >
            {icon && (
                <i
                    className={`${icon} text-xs`}
                    style={{ color: severity === "secondary" ? "#64748B" : "#FFFFFF" }}
                />
            )}
            <span>{label}</span>
        </button>
    );
};

export default MobileActionButton;